module.exports = __webpack_public_path__ + "media/favicon/mstile-150x150-263f5eb7.png";